export default __webpack_public_path__ + "static/media/text-icon.4423db84.svg";